





import StepperWidget from '@/components/widgets/StepperWidget.vue';
import { default as Component } from 'vue-class-component';
import NonCommodityStep from '@/models/NonCommodityStep';
import { Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class NonCommodityStepperWidget extends StepperWidget {
  @Prop() public stepStates!: NonCommodityStep[];

  get currentStep(): NonCommodityStep {
    // @ts-ignore
    return this.stepStates.find((step) => step.widget === this.currentWidgetKey);
  }

  public getStepIconClass(widgetKey: string): string {
    return NonCommodityStep.getStepIconClass(this.steps, widgetKey);
  }

  public isStepCurrent(widgetKey: string): boolean {
    if (this.$store.state.orderId !== null) return false;
    return NonCommodityStep.isStepCurrent(this.steps, widgetKey);
  }

  public isStepActive(widgetKey: string): boolean {
    return NonCommodityStep.isStepActive(this.steps, widgetKey);
  }

  public isStepLocked(widgetKey: string): boolean {
    return NonCommodityStep.isStepLocked(this.steps, widgetKey);
  }

  public isStepDisabled(widgetKey: string): boolean {
    return NonCommodityStep.isStepDisabled(this.steps, widgetKey);
  }

  get steps(): NonCommodityStep[] {
    return this.$props.stepStates;
  }

  public getStepTitle(step: NonCommodityStep): string {
    if (!step.isShown && this.isStepActive(step.widget) && step.isDone && step.titleDone.length > 0) {
      return step.titleDone;
    }
    return step.title;
  }

  public goToWidget(widgetName: string): void {
    if (this.isStepDisabled(widgetName) || this.isStepLocked(widgetName)) {
      return;
    }
    this.$emit('goToWidget', widgetName);
  }

  mounted(): void {
    this.goToWidget(this.currentWidgetKey);
  }

  get currentWidgetKey(): string {
    return NonCommodityStep.getCurrentStep(this.steps).widget;
  }
}
